/**
 * Slider modules
 */
export * from './slider';
